import { useEffect, useState } from "react";
import { IPanelGuardiaEliminar } from "./PanelGuardiaEliminar";
import { codigosRespuesta, IResponseApiFluent } from "../../../../interfaces/base/IResponse";
import GuardiaService from "../../../../services/guardiaService";

const UseGuardiaEliminar = (props: IPanelGuardiaEliminar) => {
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false)
    const initial: string = ""
    const [request, setRequest] = useState<string>(initial)

    const deleteRoster = () => {
        setLoading(true)
        GuardiaService.deleteGuardia(request)
            .then((res) => {
                if (res.status == 200) {
                    setStatus(200)
                    setMensaje(res.data.mensaje);
                    setTimeout(() => {
                        props.reload?.();
                        reset()
                    }, 3000)
                } else {
                    setStatus(500)
                }
                setLoading(false)
            })
            .catch((e) => {
                if (
                    e.response?.data &&
                    'type' in e.response.data &&
                    'title' in e.response.data &&
                    'status' in e.response.data &&
                    'instance' in e.response.data &&
                    'errors' in e.response.data
                ) {
                    const errorResponse = e.response.data as IResponseApiFluent;
                    const mensajeError = errorResponse.errors.join('\n');
                    setMensaje(mensajeError);
                } else {
                    setMensaje("Error Inesperado");
                }
                setStatus(500);
                setLoading(false);
            })
    }

    const reset = () => {
        setMensaje("")
        setRequest(initial)
        setStatus(0)
        props.onDismiss()
    }

    const nuevo = () => {
        setMensaje("")
        setRequest(initial)
        setStatus(0)
    }

    useEffect(() => {
        if (props.isOpen) {
            if (props.guardiaData.id != initial) {
                setRequest(props.guardiaData.id ?? "")
            }
        }
    }, [props.guardiaData, props.isOpen])


    return { request, deleteRoster, loading, reset, mensaje, status, nuevo }
}

export { UseGuardiaEliminar }